import * as api from "services/api";

import _ from "lodash";
import { emailValidation } from "../../../../helpers/validators";

import history from "../../../../history";

export const EDIT_USER = "[USER EDIT] EDIT_USER";
export const EDIT_USER_SUCCESS = "[USER EDIT] EDIT_USER_SUCCESS";
export const EDIT_USER_FAILED = "[USER EDIT] EDIT_USER_FAILED";

export const GET_USER = "[USER EDIT] GET_USER";
export const GET_USER_SUCCESS = "[USER EDIT] GET_USER_SUCCESS";
export const GET_USER_FAILED = "[USER EDIT] GET_USER_FAILED";

export const GET_ROLES = "[USER EDIT] GET_ROLES";
export const GET_ROLES_SUCCESS = "[USER EDIT] GET_ROLES_SUCCESS";
export const GET_ROLES_FAILED = "[USER EDIT] GET_ROLES_FAILED";

export const SET_VALUE = "[USER EDIT] SET_VALUE";
export const CLEAR_VALUE = "[USER EDIT] CLEAR_VALUE";

export function getUser(id) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_USER
		});

		const { token } = getState().login;

		let response = await api.sendGet("/user/" + id, {
			Authorization: "Bearer " + token
		});

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: GET_USER_SUCCESS,
				payload: json.model
			});
		} else {
			dispatch({ type: GET_USER_FAILED });
		}
	};
}

export function getRoles() {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_ROLES
		});

		const { login } = getState();

		let response = await api.sendGet("/user/Roles", {
			Authorization: "Bearer " + login.token
		});

		if (response.ok) {
			const result = await response.json();

			dispatch({
				type: GET_ROLES_SUCCESS,
				payload: result.model
			});
		} else {
			dispatch({ type: GET_ROLES_FAILED });
		}
	};
}

export function editUser() {
	return async (dispatch, getState) => {
		dispatch({
			type: EDIT_USER
		});

		const { login, userEdit } = getState();

		let { name, lastName, email, role, item } = userEdit;

		const errors = {};

		if (!name) {
			errors.name = "Informe um nome";
		}

		if (!lastName) {
			errors.lastName = "Informe um sobrenome";
		}

		if (!email) {
			errors.email = "Informe um email";
		} else if (!emailValidation(email)) {
			errors.email = "E-mail inválido";
		}

		if (!role) {
			errors.role = "Selecione uma função";
		}

		dispatch(
			setValue({
				errors
			})
		);

		if (_.keys(errors).length > 0) return dispatch({ type: EDIT_USER_FAILED });

		let response = await api.sendPut(
			"/user/" + item.id,
			{
				name,
				lastName,
				email,
				roleId: role
			},
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			const result = await response.json();

			dispatch({
				type: EDIT_USER_SUCCESS
			});

			dispatch(clearValue());

			history.push("/users/" + result.model.id);
		} else {
			// Carry the reason through: a bare EDIT_USER_FAILED hid a missing endpoint for
			// as long as this screen has existed.
			let message = "Não foi possível salvar o usuário";

			try {
				const json = await response.json();

				if (json && json.errors && json.errors.length) message = json.errors.join(", ");
			} catch (error) {
				if (response.status === 404 || response.status === 405) {
					message = "Recurso indisponível no servidor (" + response.status + ")";
				}
			}

			dispatch({ type: EDIT_USER_FAILED, payload: message });
		}
	};
}

export function setValue(payload) {
	return {
		type: SET_VALUE,
		payload
	};
}

export function clearValue() {
	return {
		type: CLEAR_VALUE
	};
}
